module.exports = __webpack_public_path__ + "media/images/icons/search_filter-65b057184518732c92358b24a7a30330.svg";